import RecordsCrud from "../components/generated-records/RecordsCrud";

const RecordsCrudPage = () => {
  return (
    <>
      <RecordsCrud />
    </>
  );
};

export default RecordsCrudPage;
